import { useMemo } from 'react';

import { LIFECYCLE, useLifecycle } from 'hooks/useLifecycle';
import type {
  CrediCardPaymentMethod,
  PaymentProvider_paymentMethod,
} from 'lib/paymentMethod';
import { PaymentMethod } from 'lib/paymentMethod';

export const usePreferredPaymentMethod = () => {
  const { update, loading, lifecycle } = useLifecycle();
  const storedPreferredPaymentMethod =
    lifecycle?.preferredPaymentMethod || null;

  const preferredPaymentMethod = useMemo(() => {
    if (storedPreferredPaymentMethod === PaymentMethod.ETH_WALLET) {
      return PaymentMethod.CRYPTO_WALLET;
    }
    return storedPreferredPaymentMethod;
  }, [storedPreferredPaymentMethod]);

  const preferredOrderedPaymentMethod = useMemo(() => {
    if (!preferredPaymentMethod) return null;
    if (typeof preferredPaymentMethod !== 'string')
      return `credit_card_${preferredPaymentMethod.id}` as CrediCardPaymentMethod;
    return preferredPaymentMethod;
  }, [preferredPaymentMethod]);

  const preferredOrderedPaymentMethodGrouped = useMemo(() => {
    if (!preferredPaymentMethod) return null;
    if (typeof preferredPaymentMethod !== 'string')
      return PaymentMethod.CREDIT_CARD;
    return preferredPaymentMethod;
  }, [preferredPaymentMethod]);

  return {
    preferredPaymentMethodIsCreditCard:
      typeof preferredPaymentMethod !== 'string',
    preferredPaymentMethod,
    preferredOrderedPaymentMethod,
    preferredOrderedPaymentMethodGrouped,
    updatePreferredPaymentMethod: async (
      pm:
        | PaymentProvider_paymentMethod
        | PaymentMethod.CRYPTO_WALLET
        | PaymentMethod.FIAT_WALLET
    ) => update(LIFECYCLE.preferredPaymentMethod, pm),
    loading,
  };
};
